<template>
	<div class="container" id="dashboard_wrap">
		<div class="row">
			<div class="col-12 text-center p-4">
				<img
					:src="this.$store.state.layout.logo"
					alt="iAMc"
					class="img-fluid p-2"
					id="iamc_logo"
				/>
				<h5 class="pt-1">
					Coopetition Board: Rolling Weekly Ranking of Time Sleeping<br /><small
						>Working together to Inspire a million people to be sleeping effectively</small
					>
				</h5>
			</div>
			<div class="col-12 text-center mb-4 table-responsive">
				<b-table
					bordered
					selectable
					table-class=""
					:items="tableData"
					:busy="isBusy"
					:fields="fields"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					sort-icon-left
				>
					<template v-slot:table-busy>
						<div class="text-center my-2 p-2">
							<b-spinner class="align-middle"></b-spinner>
							<br />
							<strong>Loading...</strong>
						</div>
					</template>

					<template v-slot:cell(name)="data">
						<div class="text-left">
							<span v-text="data.item.name"></span>
						</div>
					</template>
				</b-table>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'Dashboard',
	components: {},
	props: {},
	data() {
		return {
			isBusy: true,
			sortBy: 'total',
			sortDesc: true,
			tableData: null,
			fields: [
				{ key: 'rank', sortable: true },
				{ key: 'name', sortable: true },
				{ key: 'mon', sortable: true },
				{ key: 'tue', sortable: true },
				{ key: 'wed', sortable: true },
				{ key: 'thu', sortable: true },
				{ key: 'fri', sortable: true },
				{ key: 'sat', sortable: true },
				{ key: 'sun', sortable: true },
				{ key: 'total', label: 'Total (H:m)', sortable: true, class: 'text-center' },
			],
		};
	},
	methods: {
		boardDataGet() {
			let _this = this;
			axios({
				url: _this.$store.state.api_url + 'boardDataSleepGet',
				params: {},
			})
				.then(function (response) {
					_this.isBusy = false;
					if (response.data.status == 1) {
						_this.tableData = response.data.leaderboard;
					} else {
						_this.tableData = null;
					}
				})
				.catch(function () {
					console.log('Error: boardDataSleepGet.');
				});
		},
	},
	mounted() {
		this.boardDataGet();
	},
	computed: {},
};
</script>

<style>
.table td.table-primary {
	font-size: 1.2rem !important;
	font-weight: bold !important;
}
.table td.table-secondary {
	text-align: center !important;
}
</style>
